import React from 'react';
import PropTypes from 'prop-types';
import styles from './BackBanner.module.scss';
import { useTranslation } from 'next-i18next';

const BackBanner = ({ href, text, backToMap }) => {
    const { t } = useTranslation('common');
    return (
        <div className={styles['BackBanner']}>
            <div className={styles['BackBanner__Container']}>
                {backToMap ? (
                    <button
                        onClick={() => window.history.back()}
                        className={
                            styles['BackBanner__Clickable'] +
                            ' ' +
                            styles['BackBanner__Clickable--Map']
                        }>
                        {t('backBanner.backToMap')}
                    </button>
                ) : (
                    <a href={href} className={styles['BackBanner__Clickable']}>
                        {text}
                    </a>
                )}
            </div>
        </div>
    );
};

BackBanner.propTypes = {
    href: PropTypes.string,
    text: PropTypes.string,
    backToMap: PropTypes.bool,
};

BackBanner.defaultProps = {
    href: '',
    text: '',
    backToMap: false,
};

export default BackBanner;
